import styled from 'styled-components';
import { InfoCircle } from '@styled-icons/boxicons-regular/InfoCircle';

export const SendProjectContent = styled.div``;

export const NewProjectRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  width: 100%;

  & > div:first-child {
    margin-right: 1rem;
  }
`;

export const DataInputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: none;

  & > .subtitle {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
    display: flex;
  }

  & > .ant-select,
  .ant-input {
    margin-right: 1rem;
    width: 15.938rem;
    font-size: 0.75rem;

    & > .ant-select-selector {
      border-radius: 0.25rem;
    }
  }
`;

export const InfoIcon = styled(InfoCircle)`
  width: 1.25rem;
  color: ${({ theme }) => theme.colors.grayDark2};
  margin-left: 0.5rem;
`;
